import {
  Autocomplete,
  Card,
  CardContent,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { BiRefresh } from "react-icons/bi";
import { Wallet } from "../../../../app/slices/walletSlice";

const months = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

const monthNumberToDate = (monthNumber) =>
  dayjs(`${dayjs().year()}-${monthNumber}-01`).format("YYYY-MM-DD");

// Shared between the "المعاملات المالية", "مناقلات الدفع الالكتروني" and
// "الدفع الالكتروني" tabs so all three show the same financial summary.
const FinancialInfoCard = () => {
  const dispatch = useDispatch();
  const { user_id } = useParams();
  const user = useSelector((state) => state.user.user.form);
  const _WalletReload = useSelector((state) => state.wallet.reload);
  const _MonthlyRep = useSelector((state) => state.wallet.monthlyRep);

  const [selectedMonth, setSelectedMonth] = useState(dayjs().format("MM"));

  useEffect(() => {
    if (user.is_representative)
      dispatch(
        Wallet.getMonthlyRep({
          rep_id: user_id,
          date: monthNumberToDate(selectedMonth),
        }),
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id, _WalletReload, selectedMonth, user.is_representative]);

  return (
    <Card
      sx={{
        background: "linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <CardContent>
        <Stack spacing={2}>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#388e3c", mb: 1 }}
          >
            المعلومات المالية
          </Typography>
          <Typography
            variant="h5"
            sx={{ color: "#388e3c", fontWeight: "bold" }}
          >
            الرصيد: {user.wallet?.balance?.toLocaleString()} د.ع
          </Typography>
          <Typography
            variant="h5"
            sx={{ color: "#d32f2f", fontWeight: "bold" }}
          >
            الديون: {user.wallet?.debt?.toLocaleString()} د.ع
          </Typography>
          {!user.is_representative && (
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="body1" sx={{ color: "#388e3c" }}>
                <strong>فرق الرصيد:</strong>{" "}
                {user.wallet?.balance_difference?.toLocaleString()} د.ع
              </Typography>
              <IconButton
                size="small"
                onClick={() => dispatch(Wallet.checkBalanceDifference(user.id))}
              >
                <BiRefresh />
              </IconButton>
            </Stack>
          )}
          {user.is_representative && (
            <Typography
              variant="h5"
              sx={{ color: "#388e3c", fontWeight: "bold" }}
            >
              الكاش: {user.wallet?.cash?.toLocaleString()} د.ع
            </Typography>
          )}
          {user.is_representative ? (
            <Stack
              spacing={1.5}
              sx={{
                mt: 1,
                pt: 1.5,
                borderTop: "1px dashed #a5d6a7",
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography
                  variant="body2"
                  sx={{ color: "#388e3c", fontWeight: "bold" }}
                >
                  مبيعات المندوب لشهر:
                </Typography>
                <Autocomplete
                  size="small"
                  options={months}
                  getOptionLabel={(option) => option}
                  value={
                    months.filter((x) => x === selectedMonth)[0] ??
                    dayjs().format("MM")
                  }
                  onChange={(e, newValue) => {
                    setSelectedMonth(newValue ? newValue : dayjs().format("MM"));
                  }}
                  isOptionEqualToValue={(option, value) => option === value}
                  renderInput={(params) => (
                    <TextField {...params} size="small" sx={{ width: 90 }} />
                  )}
                />
              </Stack>
              <Stack direction="row" spacing={1.5} flexWrap="wrap">
                {_MonthlyRep.data.total_income ? (
                  <Stack
                    sx={{
                      bgcolor: "#f1f8e9",
                      borderRadius: 1.5,
                      px: 1.5,
                      py: 0.75,
                      border: "1px solid #c5e1a5",
                      minWidth: 110,
                    }}
                  >
                    <Typography variant="caption" sx={{ color: "#558b2f" }}>
                      إجمالي المبيعات
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "#388e3c", fontWeight: "bold" }}
                    >
                      {_MonthlyRep.data.total_income.toLocaleString()} د.ع
                    </Typography>
                  </Stack>
                ) : null}
                {_MonthlyRep.data.total_e_payment ? (
                  <Stack
                    sx={{
                      bgcolor: "#e8f5e9",
                      borderRadius: 1.5,
                      px: 1.5,
                      py: 0.75,
                      border: "1px solid #a5d6a7",
                      minWidth: 110,
                    }}
                  >
                    <Typography variant="caption" sx={{ color: "#558b2f" }}>
                      مبيعات الدفع الالكتروني
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "#388e3c", fontWeight: "bold" }}
                    >
                      {_MonthlyRep.data.total_e_payment.toLocaleString()} د.ع
                    </Typography>
                  </Stack>
                ) : null}
              </Stack>
            </Stack>
          ) : null}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default FinancialInfoCard;
